import { proxy } from 'valtio';

const unreachable = (value: never) => {
  throw new Error(`Not implemented: ${value}`);
};

export type MenuData =
  | {
      type: 'field';
      fieldId: string;
      panel?: boolean;
    }
  | {
      type: 'entry';
      entryId: string;
      panel?: boolean;
    }
  | {
      type: 'value';
      fieldId: string;
      entryId: string;
      panel?: boolean;
    };

interface ContextualMenuState {
  menuData: MenuData | null;
  showMenu: (menu: MenuData) => void;
  closeMenu: () => void;
  isMenuOpen: (menu: MenuData | null) => boolean;
  isAnyMenuOpen: () => boolean;
  isPanel: () => boolean;
}

export const contextualMenuState = proxy<ContextualMenuState>({
  menuData: null,
  showMenu(menu: MenuData) {
    this.menuData = menu;
  },
  closeMenu() {
    this.menuData = null;
  },
  isMenuOpen(menu: MenuData | null): boolean {
    if (!menu) {
      return this.menuData !== null;
    }

    const type = menu?.type;
    if (!type) {
      return false;
    }
    switch (type) {
      case 'field':
        return this.menuData?.type === 'field' && this.menuData.fieldId === menu?.fieldId;
      case 'entry':
        return this.menuData?.type === 'entry' && this.menuData.entryId === menu?.entryId;
      case 'value':
        return (
          this.menuData?.type === 'value' &&
          this.menuData.fieldId === menu?.fieldId &&
          this.menuData.entryId === menu?.entryId
        );
      default:
        return unreachable(type);
    }
  },
  isAnyMenuOpen(): boolean {
    return this.menuData !== null;
  },
  isPanel(): boolean {
    if (this.menuData && 'panel' in this.menuData) {
      return !!this.menuData.panel;
    }
    return false;
  },
});
